import React from "react";

export const CustomSVGIcon = ({ status }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g
        transform="translate(-2 -2)"
        className={status === "active" ? "category-svg-active" : "category-svg-inactive"}
      >
        <path
          className="svg-path"
          d="M44.2,9A1.2,1.2,0,0,0,43,10.2h2.4A1.2,1.2,0,0,0,44.2,9Z"
          transform="translate(-24.6 -4.2)"
        />
        <path
          className="svg-path"
          d="M6.481,59.6h.975l.2-1.6H6.281Z"
          transform="translate(-2.569 -33.6)"
        />
        <path
          className="svg-path"
          d="M44.6,2H33V12.8H44.6Zm-2.087,9.849A.4.4,0,0,1,42.2,12h-8a.4.4,0,0,1-.39-.49l1.2-5.2A.4.4,0,0,1,35.4,6h.8a2,2,0,0,1,4,0H41a.4.4,0,0,1,.39.31l1.2,5.2A.4.4,0,0,1,42.513,11.849Z"
          transform="translate(-18.6)"
        />
        <path
          className="svg-path"
          d="M54.481,59.6h.975l.2-1.6H54.281Z"
          transform="translate(-31.369 -33.6)"
        />
        <path
          className="svg-path"
          d="M44.344,15.6l.533-1.6h-4.49l.533,1.6Zm-2.112-1.2h.8v.8h-.8Z"
          transform="translate(-23.033 -7.2)"
        />
        <path
          className="svg-path"
          d="M12,48.4h-.8V48H8v.4a.4.4,0,0,0,.4.4h6.4a.4.4,0,0,0,.4-.4V48H12Z"
          transform="translate(-3.6 -27.6)"
        />
        <path
          className="svg-path"
          d="M13.6,2H2V12.8H13.6Zm-.8,9.6a.4.4,0,0,1-.4.4h-8a.4.4,0,0,1-.4-.4V5.2a.4.4,0,0,1,.4-.4h8a.4.4,0,0,1,.4.4Z"
        />
        <path
          className="svg-path"
          d="M9,11.192l3.6,2.52,3.6-2.52V11H9Z"
          transform="translate(-4.2 -5.4)"
        />
        <path
          className="svg-path"
          d="M13.6,31H2V41H13.6Zm-1.2,7.2a1.2,1.2,0,0,1-1.2,1.2H4.8a1.2,1.2,0,0,1-1.2-1.2V35a1.2,1.2,0,0,1,1.2-1.2h6.4A1.2,1.2,0,0,1,12.4,35Z"
          transform="translate(0 -17.4)"
        />
        <path
          className="svg-path"
          d="M14.8,40H8.4a.4.4,0,0,0-.4.4v2h3.2v-.8H12v.8h3.2v-2A.4.4,0,0,0,14.8,40Z"
          transform="translate(-3.6 -22.8)"
        />
        <path
          className="svg-path"
          d="M40,50h4.8v.8H40Z"
          transform="translate(-22.8 -28.8)"
        />
        <path
          className="svg-path"
          d="M40,41h4.8v2.8H40Z"
          transform="translate(-22.8 -23.4)"
        />
        <path
          className="svg-path"
          d="M12.6,16.353a.4.4,0,0,1-.229-.072L9,13.921v4.432h7.2V13.921l-3.371,2.36A.4.4,0,0,1,12.6,16.353Z"
          transform="translate(-4.2 -7.153)"
        />
        <path
          className="svg-path"
          d="M45.4,36.2a1.2,1.2,0,1,0-2.4,0v.4h2.4Z"
          transform="translate(-24.6 -19.8)"
        />
        <path
          className="svg-path"
          d="M44.6,31H33V41H44.6Zm-3.2,8.8a.4.4,0,0,1-.4.4H35.4a.4.4,0,0,1-.4-.4V34.6a.4.4,0,0,1,.4-.4h.8v-.4a2,2,0,0,1,4,0v.4H41a.4.4,0,0,1,.4.4Z"
          transform="translate(-18.6 -17.4)"
        />
        <path
          className="svg-path"
          d="M43.134,17.739a.4.4,0,0,1-.38.274h-4a.4.4,0,0,1-.38-.274l-.35-1.052-.767,3.325h6.994l-.767-3.325Z"
          transform="translate(-21.154 -8.812)"
        />
      </g>
    </svg>
  );
}